// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pokemon-details-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-family: 'Poppins';
    height: 100vh;
}

.pokemon-details-box-wrap {
    border-radius: 5px;
    border: 1px solid #000;
    padding: 10px 50px;
    width: 350px;
    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.5);
}

.details-pokemon-name {
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: capitalize;
    font-size: 28px;
}

.list-stat-name {
    gap: 4px;
}

.stat-name {
    display: flex;
}

.stat-name svg {
    font-size: 24px;
}

li {
    list-style: none;
    display: flex;
}

.bold-stat {
    font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/style/PokemonDetailsStyle.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".pokemon-details-box {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    font-family: 'Poppins';\n    height: 100vh;\n}\n\n.pokemon-details-box-wrap {\n    border-radius: 5px;\n    border: 1px solid #000;\n    padding: 10px 50px;\n    width: 350px;\n    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.5);\n}\n\n.details-pokemon-name {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-transform: capitalize;\n    font-size: 28px;\n}\n\n.list-stat-name {\n    gap: 4px;\n}\n\n.stat-name {\n    display: flex;\n}\n\n.stat-name svg {\n    font-size: 24px;\n}\n\nli {\n    list-style: none;\n    display: flex;\n}\n\n.bold-stat {\n    font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
